import { render, staticRenderFns } from "./tab-combos.vue?vue&type=template&id=28a0698b&scoped=true&"
import script from "./tab-combos.vue?vue&type=script&lang=js&"
export * from "./tab-combos.vue?vue&type=script&lang=js&"
import style0 from "./tab-combos.vue?vue&type=style&index=0&id=28a0698b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0698b",
  null
  
)

export default component.exports